import { createAsyncThunk } from '@reduxjs/toolkit'

import { sleep } from '../../../utils/promise.helpers'
import { ThunkApi } from '../../../store/index.d'
import { storeBuildNeededUpdate } from '../../../store/persist'

declare var __webpack_hash__: string

export const validateBuildVersion = createAsyncThunk<void, void, ThunkApi>(
  '[LOGIN] VALIDATE_BUILD_VERSION',
  async (_, { dispatch, rejectWithValue }) => {
    const response = await fetch('/')
    const html = await response.text()

    const start = html.indexOf('/js/main.') + 9
    const end = html.indexOf('.chunk.js', start)
    const nextHash = html.substring(start, end)
    const currentHash = __webpack_hash__

    if (currentHash !== nextHash) {
      dispatch(storeBuildNeededUpdate())
      await sleep(200)
      window.location.reload()
      return rejectWithValue('App build needs to be updated')
    }
  },
)
